import { createFieldGroup } from '@theme/dom-utils';

function buildOrderNote(giftMessage, receiverName, senderName, specialRequest) {
  const giftLines = [];
  if (giftMessage?.trim()) giftLines.push(`Gift message: ${giftMessage.trim()}`);
  if (receiverName?.trim()) giftLines.push(`Receiver's name: ${receiverName.trim()}`);
  if (senderName?.trim()) giftLines.push(`Sender's name: ${senderName.trim()}`);
  const giftBlock = giftLines.length ? giftLines.join('\n') : '-';
  const specialBlock = specialRequest?.trim() ? specialRequest.trim() : '-';
  return `Gift Request:\n${giftBlock}\n\nSpecial Request:\n${specialBlock}`;
}

async function removeGiftFromCart() {
  try {
    const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await cartRes.json();
    const attrs = cart.attributes || {};
    const special = (attrs.special_request || '').toString();
    const note = buildOrderNote('', '', '', special);
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { gift_message: '', receiver_name: '', sender_name: '' },
        note,
      }),
    });
    const noteInput = document.querySelector('form#cart-form input[name="note"]');
    if (noteInput) noteInput.value = note;
  } catch (error) {
    console.warn('Failed to remove gift from cart', error);
  }
}

async function saveSpecialToCart(specialVal) {
  try {
    const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await cartRes.json();
    const attrs = cart.attributes || {};
    const note = buildOrderNote(
      attrs.gift_message || '',
      attrs.receiver_name || '',
      attrs.sender_name || '',
      specialVal || '',
    );
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          gift_message: attrs.gift_message || '',
          receiver_name: attrs.receiver_name || '',
          sender_name: attrs.sender_name || '',
          special_request: specialVal || '',
        },
        note,
      }),
    });
    const noteInput = document.querySelector('form#cart-form input[name="note"]');
    if (noteInput) noteInput.value = note;
  } catch (error) {
    console.warn('Failed to save special request to cart', error);
  }
}

function hideAccordionOpen(type) {
  const accordion = document.querySelector(`[data-cart-accordion="${type}"]`);
  if (!accordion) return;
  const panel = accordion.querySelector('.cart__acc-panel');
  const body = accordion.querySelector(`[data-acc-body="${type}"]`);
  accordion.classList.remove('is-open');
  if (panel) panel.hidden = true;
  if (body) body.replaceChildren();
  const header = accordion.querySelector('.cart__acc-header');
  if (header) header.setAttribute('aria-expanded', 'false');
}

function getAccordionLabels() {
  const el = document.querySelector('.cart__accordions');
  if (!el) {
    return {
      giftMessage: 'Gift message:',
      receiverName: "Receiver's name:",
      senderName: "Sender's name:",
      specialRequest: 'Special Request:',
    };
  }
  return {
    giftMessage: el.dataset.labelGiftMessage || 'Gift message:',
    receiverName: el.dataset.labelReceiverName || "Receiver's name:",
    senderName: el.dataset.labelSenderName || "Sender's name:",
    specialRequest: el.dataset.labelSpecialRequest || 'Special Request:',
  };
}

function updateAccordionsFromCart(cart) {
  const attrs = cart?.attributes || {};
  const labels = getAccordionLabels();
  const gMsg = (attrs.gift_message || '').toString().trim();
  const gRecv = (attrs.receiver_name || '').toString().trim();
  const gSend = (attrs.sender_name || '').toString().trim();
  const special = (attrs.special_request || '').toString().trim();
  const hasGift = !!(gMsg || gRecv || gSend);
  const hasSpecial = !!special;

  const giftAcc = document.querySelector('[data-cart-accordion="gift"]');
  if (giftAcc) {
    const panel = giftAcc.querySelector('.cart__acc-panel');
    const body = giftAcc.querySelector('[data-acc-body="gift"]');
    const header = giftAcc.querySelector('.cart__acc-header');
    giftAcc.classList.toggle('is-open', hasGift);
    if (panel) panel.hidden = !hasGift;
    if (header) header.setAttribute('aria-expanded', hasGift ? 'true' : 'false');
    if (body) {
      body.replaceChildren();
      if (hasGift) {
        if (gMsg) body.appendChild(createFieldGroup(labels.giftMessage, gMsg));
        if (gRecv) body.appendChild(createFieldGroup(labels.receiverName, gRecv, true));
        if (gSend) body.appendChild(createFieldGroup(labels.senderName, gSend, true));
      }
    }
  }

  const specialAcc = document.querySelector('[data-cart-accordion="special-request"]');
  if (specialAcc) {
    const panel = specialAcc.querySelector('.cart__acc-panel');
    const body = specialAcc.querySelector('[data-acc-body="special-request"]');
    const header = specialAcc.querySelector('.cart__acc-header');
    specialAcc.classList.toggle('is-open', hasSpecial);
    if (panel) panel.hidden = !hasSpecial;
    if (header) header.setAttribute('aria-expanded', hasSpecial ? 'true' : 'false');
    if (body) {
      body.replaceChildren();
      if (hasSpecial) {
        body.appendChild(createFieldGroup(labels.specialRequest, special));
      }
    }
  }
}

document.addEventListener('cart:updated', (e) => {
  if (e.detail?.cart) updateAccordionsFromCart(e.detail.cart);
});

document.addEventListener('click', (e) => {
  const removeBtn = e.target.closest('[data-acc-remove]');
  if (!removeBtn) return;
  const type = removeBtn.dataset.accRemove;
  hideAccordionOpen(type);
  if (type === 'gift') removeGiftFromCart();
  else saveSpecialToCart('');
});
